import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useAuth } from '../../../context/AuthContext';

export function MeetingModal({ event, slotInfo, onClose, onSave }) {
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    title:'', description:'', location:'', attendees:'', category:'Reunión', reminder_minutes:15,
    start_time:'', end_time:'', company: '', color: '#3174ad'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(()=>{
    if (event) {
      setFormData({
        ...event,
        start_time: format(event.start, "yyyy-MM-dd'T'HH:mm"),
        end_time: format(event.end, "yyyy-MM-dd'T'HH:mm"),
        company: event.company || '',
        color: event.color || '#3174ad',
      });
    } else if (slotInfo) {
      setFormData(prev=>({
        ...prev,
        start_time: format(slotInfo.start,"yyyy-MM-dd'T'HH:mm"),
        end_time: format(slotInfo.end,"yyyy-MM-dd'T'HH:mm"),
        company: 'PERSONAL',
        color: '#3174ad',
      }));
    }
  }, [event, slotInfo]);

  const handleChange = (e)=> setFormData(prev=>({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e)=>{
    e.preventDefault(); setLoading(true); setMessage('');
    const url = event ? `/api/owner/meetings/${event.id}` : '/api/owner/meetings';
    const method = event ? 'PUT' : 'POST';
    try {
      const r = await fetch(url, { method, headers:{ 'Content-Type':'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(formData) });
      const d = await r.json();
      if (r.ok) { setMessage(event ? 'Reunión actualizada.' : 'Reunión creada.'); setTimeout(onSave, 700); }
      else setMessage(`Error: ${d.mensaje}`);
    } catch { setMessage('Error de conexión.'); }
    finally { setLoading(false); }
  };

  const handleDelete = async ()=>{
    if (!event || !window.confirm('¿Eliminar esta reunión?')) return;
    setLoading(true);
    try {
      const r = await fetch(`/api/owner/meetings/${event.id}`, { method:'DELETE', headers:{ 'Authorization': `Bearer ${token}` }});
      if (r.ok) { setMessage('Reunión eliminada.'); setTimeout(onSave, 700); }
      else { const d=await r.json(); setMessage(`Error: ${d.mensaje}`); }
    } catch { setMessage('Error de conexión.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" />
      <div className="relative w-full max-w-lg overflow-hidden rounded-2xl border border-white/10 bg-white shadow-2xl" onClick={(e)=>e.stopPropagation()}>
        <div className="bg-gradient-to-r from-slate-900 to-slate-700 px-6 py-5">
          <h3 className="text-lg font-semibold text-white">{event ? 'Editar reunión' : 'Nueva reunión'}</h3>
          <p className="text-slate-300 text-sm mt-1">Agenda y organiza tus compromisos.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-10">
                <input name="title" value={formData.title} onChange={handleChange} placeholder="Título" required
                  className="w-full h-10 rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"/>
              </div>
              <div className="col-span-2">
                <input type="color" name="color" value={formData.color} onChange={handleChange} title="Color del evento"
                  className="w-full h-10 rounded-xl border-slate-200 p-1 cursor-pointer"/>
              </div>
            </div>

            <label className="text-xs text-slate-600">Inicio</label>
            <input type="datetime-local" name="start_time" value={formData.start_time} onChange={handleChange}
              className="w-full rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"/>
            <label className="text-xs text-slate-600">Fin</label>
            <input type="datetime-local" name="end_time" value={formData.end_time} onChange={handleChange}
              className="w-full rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"/>
            <textarea name="description" value={formData.description||''} onChange={handleChange} placeholder="Descripción (opcional)"
              className="w-full rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"/>
          </div>

          <div className="border-t bg-slate-50 px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              {event && (
                <button type="button" onClick={handleDelete}
                  className="rounded-xl bg-rose-50 px-4 py-2 text-rose-700 hover:bg-rose-100">Eliminar</button>
              )}
              <span className={`text-sm ${message.includes('Error') ? 'text-rose-600' : 'text-emerald-600'}`}>{message}</span>
            </div>
            <div className="flex gap-3">
              <button type="button" onClick={onClose}
                className="rounded-xl px-4 py-2 bg-white border border-slate-200 text-slate-700 hover:bg-slate-50">Cancelar</button>
              <button type="submit" disabled={loading}
                className="rounded-xl px-4 py-2 bg-slate-900 text-white shadow-lg hover:shadow-xl disabled:opacity-50">{loading ? '...' : 'Guardar'}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
